import { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/images/logo.png";

function Header() {

  const [menuOpen, setMenuOpen] = useState(false);


  return (
    <header className="header-area header-sticky wow slideInDown">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <nav className="main-nav">

              {/* Logo */}
              <NavLink to="/" className="logo">
                <img src={logo} alt="logo" />
              </NavLink>

              {/* Menu */}
              <ul className={`nav ${menuOpen ? "active" : ""}`}>

                <li><NavLink to="/" end>Home</NavLink></li>
                <li><NavLink to="/about">About</NavLink></li>
                <li><NavLink to="/services">Services</NavLink></li>
                <li><NavLink to="/blog">Blog</NavLink></li>
                <li>
                  <div className="gradient-button">
                    <NavLink to="/contact">Contact Us</NavLink>
                  </div>
                </li>

              </ul>

              {/* Menu Button */}
              <button 
                className={`menu-trigger ${menuOpen ? "active" : ""}`}
                onClick={() => setMenuOpen(!menuOpen)}
              >
                <span>Menu</span>
              </button>

            </nav>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;